import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TooltipButton from './TooltipButton';

function CopyButton({ inputRef = null, handleClick = null, labelText = '', textToCopy, ...rest }) {
  const [copySuccess, setCopySuccess] = useState(false);
  const { t } = useTranslation();
  const label = labelText || t('common:labels.copy');

  const copyToClipboard = () => {
    if (handleClick) {
      handleClick();
    } else if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        setCopySuccess(t('common:labels.copied'));
      });
    } else {
      if (inputRef && inputRef.current) inputRef.current.select();
      document.execCommand('copy');
    }
    setCopySuccess(t('common:labels.copied'));
  };

  useEffect(() => {
    let copyTimer;
    if (copySuccess) copyTimer = setTimeout(() => setCopySuccess(false), 1000);
    return () => clearTimeout(copyTimer);
  }, [copySuccess]);

  return (
    <TooltipButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      onClick={copyToClipboard}
      text={copySuccess || label}
    >
      <i className="fas fa-copy text-lg" />
    </TooltipButton>
  );
}

CopyButton.propTypes = {
  /**
   * DOM element for input field to copy from
   */
  inputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  /**
   * Function to call if not selecting a DOM element
   */
  handleClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  /**
   * Label text to give details about what will be copied
   */
  labelText: PropTypes.string,
};

export default CopyButton;
